
      $(document).ready(function(){

          $("#smartwizard").on("showStep", function() {
              $("#next-btn").removeClass('disabled');

          });

     
          $('#smartwizard').smartWizard({
              selected: 0,
              theme: 'arrows',
              transition: {
                  animation: 'slide-horizontal',
              },

          });

          $("#next-btn").on("click", function() {
              $('#smartwizard').smartWizard("next");
              return true;
          });



      });
